import { getPoints } from '@api/dashboard';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { BenefitsState } from '@utils/types';

export const getBenefitsData = createAsyncThunk('getBenefitsData', async () => {
  const points = await getPoints();

  return {
    points: points.points,
  };
});

const initialState: BenefitsState = {
  points: 0,
  currentBenefitData: {
    id: '',
    logo: '',
    bannerLogo: '',
    logoActive: '',
    header: '',
    desc: '',
    text: '',
  },
  error: false,
};

const benefitsSlice = createSlice({
  name: 'benefits',
  initialState,
  reducers: {
    setCurrentBenefitData: (state, action) => {
      state.currentBenefitData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBenefitsData.fulfilled, (state, action) => {
      if (action.payload?.points) {
        state.points = action.payload.points;
      }
      state.error = false;
    });
    builder.addCase(getBenefitsData.rejected, (state) => {
      state.error = true;
    });
  },
});

export const { setCurrentBenefitData } = benefitsSlice.actions;

export default benefitsSlice.reducer;
